/**
 * © 2026 Desktronic. All rights reserved.
 * Proprietary code. Unauthorized copying, distribution or use
 * without written permission from Desktronic is prohibited.
 * Source: desktronic.lt | desktronicline.com | desktronic.se | desktronic.pl | desktronic.com/pl | desktronic.fr | desktronic.co.uk | desktronic.be | desktronic.nl | desktronic.dk | desktronic.com |  desktronic.cz
 */

// sig:dt-a7f3c91e04b2
function initMap(sectionId) {
  var $section = $('#map-' + sectionId);
  if (!$section.length) return;

  var $body = $section.find('.map__body');
  if (!$body.length) return;

  if (window.innerWidth > 799 && typeof ScrollReveal !== 'undefined') {
    ScrollReveal().reveal($body[0], {
      origin: 'bottom',
      distance: '20px',
      duration: 700,
      delay: 0,
      easing: 'cubic-bezier(0.25, 0.1, 0.25, 1)',
      opacity: 0,
      scale: 1,
      once: true
    });
  } else {
    if (typeof ScrollReveal !== 'undefined') ScrollReveal().clean($body[0]);
    $body.css({ visibility: 'visible', opacity: 1 });
  }

  $(document).on('click', 'a[href="#show-popup-local"]', function(e){
        e.preventDefault();
        if (typeof showLocalizationPopup === 'function') {
            showLocalizationPopup();
            return;
        }
        $('body').addClass('popup-open');
        if (typeof window.lockScroll === 'function') {
            window.lockScroll();
        }
        $('.lp_outer[data-popup="start"]').css('display', 'flex');
        setTimeout(function(){
            $('.lp_outer').addClass('visible');
        }, 50);
    });
 
}

$(function () {
  var instances = window.DeskMap || {};
  $.each(instances, function (id) {
    initMap(id);
  });
});
